import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator function to check if a control's value is not zero.
 * This function returns a ValidatorFn that can be used to validate form controls in Angular.
 *
 * The validator performs the following checks:
 * 1. If the value is null, an empty string, or not a number, it skips validation and returns null.
 * 2. If the value is a number and is exactly zero, it returns a validation error object with the key 'nonZero' set to true.
 * 3. If the value is a number and is not zero, it returns null indicating no validation errors.
 *
 * @returns A ValidatorFn that checks if the control's value is not zero.
 */
export function nonZeroValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    // Skip validation for non-numeric or empty values
    if (value === null || value === '' || isNaN(value)) {
      return null;
    }

    const numValue = Number(value);

    // Skip if conversion fails
    if (isNaN(numValue)) {
      return null;
    }
    // Return validation error if value is zero, otherwise return null
    return numValue === 0 ? { nonZero: true } : null;
  };
}
